/**
 * Generate a unique sample ID
 */
export function generateSampleId(): string {
  return Math.random().toString(36).substring(2, 10);
}
